import { apiClient } from "@/http";
import type { UserRole } from "@/app/userRole";
import { apiRoutes } from "./apiRoutes";

// admin org 디렉터리. GitHub org 멤버/팀을 실시간으로 조합하고 registry 상태를 조인한 뷰다.
// admin 만 쓸 수 있다. 경계 타입은 서버 응답과 같은 snake_case 다.
// email·created_at(가입일)은 의도적으로 포함하지 않는다.

// Registry 그룹 소속 한 건과 출처. explicit 는 admin 명시 매핑(a축)이다.
// github_team 은 GitHub팀 자동 매핑(b축)이다.
export type RegistryGroupRef = {
  group_uuid: string;
  name: string;
  source: "explicit" | "github_team";
};

// 멤버에 매핑된 training workspace 스냅샷 1건(목록 셀 표시용). 상세 편집은 WorkspaceMappingModal 이
// 한다.
export type OrgMemberWorkspaceRef = {
  training_workspace_id: string;
  workspace_name: string;
};

// org 멤버 한 명(가입+미가입). github_user_id 가 안정 키다. login 이 바뀌어도 그대로다.
export type OrgMemberView = {
  github_user_id: number;
  github_login: string;
  avatar_url: string | null;
  // 이 유저의 GitHub 팀명들.
  github_teams: string[];
  // 첫 로그인 완료 여부. 가입하지 않았으면 tier·member_uuid 가 null 이다.
  registered: boolean;
  member_uuid: string | null;
  tier: UserRole | null;
  last_login_at: string | null;
  // 현재 소속 TrainingGroup 과 출처. 가입 전에도 명시 매핑과 GitHub팀 매핑으로 값이 있다.
  registry_groups: RegistryGroupRef[];
  // 매핑된 training workspace 스냅샷(목록 셀 "X 외 N개" 표시용). 가입자만 값이 있다.
  // 가입하지 않았으면 빈 배열이다.
  training_workspaces: OrgMemberWorkspaceRef[];
};

// GitHub 팀 노드. b축 매핑(GitHub팀↔TrainingGroup) 표시와 드롭다운 후보에 쓴다.
// registry_group 은 매핑된 그룹이다.
export type OrgTeamNode = {
  github_team_name: string;
  slug: string;
  registry_group: { uuid: string; name: string } | null;
  member_github_ids: number[];
};

export type OrgDirectoryView = {
  teams: OrgTeamNode[];
  // org 전체(가입+미가입). github_user_id 로 중복을 제거한다.
  members: OrgMemberView[];
  // 어느 GitHub 팀에도 없는 멤버.
  unteamed_github_ids: number[];
};

export async function getOrgDirectory(): Promise<OrgDirectoryView> {
  const response = await apiClient.get<OrgDirectoryView>(apiRoutes.admin.orgDirectory);
  return response.data;
}
